import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'template',
    'school',
    'county',
    'classroom',
    'virtual',
    'area',
    'select',
    'option',
    'indicator',
    'accordionContent',
    'accordionIcon',
  ];
  static values = { counter: Number };

  connect() {
    if (this.hasIndicatorTarget) {
      const selectElement = this.element.querySelector('select');

      if (selectElement && selectElement.value && selectElement.value !== '') {
        this.indicatorTarget.classList.remove('tw-bg-gray-200');
        this.indicatorTarget.style.backgroundColor = '#bfdbfe';
      } else {
        this.indicatorTarget.style.backgroundColor = '';
        this.indicatorTarget.classList.add('tw-bg-gray-200');
      }
    }
  }

  updateIndicator(event) {
    if (this.hasIndicatorTarget) {
      const value = event.target.value;

      if (value && value !== '') {
        this.indicatorTarget.classList.remove('tw-bg-gray-200');
        this.indicatorTarget.style.backgroundColor = '#bfdbfe';
      } else {
        this.indicatorTarget.style.backgroundColor = '';
        this.indicatorTarget.classList.add('tw-bg-gray-200');
      }
    }
  }

  addRow(event) {
    event.preventDefault();
    let date = new Date().getTime();
    let content = this.templateTarget.innerHTML.replace(/333/g, `${date}`);
    this.areaTarget.insertAdjacentHTML('beforeend', content);
  }

  removeRow(event) {
    event.preventDefault();
    let proceed = confirm('Certeza que deseja eliminar essa linha?');
    if (proceed) {
      let wrapper = event.target.closest('.nested-fields');
      wrapper.remove();
    }
  }

  addEmptyOption(target) {
    target.innerHTML = '';
    const option = document.createElement('option');
    option.value = null;
    option.innerHTML = 'Escolha uma opção';
    target.appendChild(option);
  }

  updateDropdown(data, target) {
    this.addEmptyOption(target);
    data.forEach((school) => {
      const option = document.createElement('option');
      option.value = school.id;
      option.innerHTML = school.name;
      target.appendChild(option);
    });
  }

  selectCounty() {
    const element = this.countyTarget;
    const countyId = element.value;
    $.ajax({
      type: 'get',
      url: element.dataset.way + '.json',
      data: new URLSearchParams({ county_id: countyId }).toString(),
      success: (data) => {
        this.updateDropdown(data, this.schoolTarget);
      },
    });
  }

  selectSchool() {
    const element = this.schoolTarget;
    const schoolId = element.value;
    $.ajax({
      type: 'get',
      url: element.dataset.way + '.json',
      data: new URLSearchParams({ school_id: schoolId }).toString(),
      success: (data) => {
        this.updateDropdown(data, this.classroomTarget);
      },
    });
  }

  selectSchoolClass() {
    const element = this.classroomTarget;
    const classId = element.value;
    $.ajax({
      type: 'get',
      url: element.dataset.way + '.json',
      data: new URLSearchParams({ school_class_id: classId }).toString(),
      success: (data) => {
        this.updateDropdown(data.virtual_classrooms, this.virtualTarget);
        this.updateDropdown(data.students, this.selectTarget);
      },
    });
  }

  toggleSelect() {
    let selectWrapper = document.getElementById(`student-ids${this.optionTarget.dataset.index}`);
    let select = document.getElementById(`student-ids-select${this.optionTarget.dataset.index}`);
    if (this.optionTarget.value === 'Alunos específicos') {
      selectWrapper.classList.remove('d-none');
      select.disabled = false;
      select.classList.remove('d-none');
    } else {
      selectWrapper.classList.add('d-none');
      select.disabled = true;
      select.classList.add('d-none');
    }
  }

  toggleAccordion() {
    if (!this.hasAccordionContentTarget || !this.hasAccordionIconTarget) return;

    const content = this.accordionContentTarget;
    const icon = this.accordionIconTarget;

    // Check if content is currently hidden
    const isHidden = content.classList.contains('tw-hidden');

    if (isHidden) {
      // Open accordion
      content.classList.remove('tw-hidden');
      content.style.maxHeight = '0px';
      content.style.opacity = '0';

      // Trigger reflow
      content.offsetHeight;

      // Animate to full height
      content.style.transition = 'max-height 0.3s ease-in-out, opacity 0.3s ease-in-out';
      content.style.maxHeight = content.scrollHeight + 'px';
      content.style.opacity = '1';

      // Rotate icon
      icon.style.transform = 'rotate(180deg)';
    } else {
      // Close accordion
      content.style.maxHeight = content.scrollHeight + 'px';
      content.style.transition = 'max-height 0.3s ease-in-out, opacity 0.3s ease-in-out';

      // Trigger reflow
      content.offsetHeight;

      // Animate to zero
      content.style.maxHeight = '0px';
      content.style.opacity = '0';

      // Hide after animation completes
      setTimeout(() => {
        content.classList.add('tw-hidden');
        content.style.maxHeight = '';
      }, 300);

      // Reset icon rotation
      icon.style.transform = 'rotate(0deg)';
    }
  }
}
